import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";

function ShareConfirmationModal({ isOpen, toggle, onConfirm }) {
  const { t } = useTranslation();
  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={9999}
    >
      <ModalHeader toggle={toggle}>
        {t('sales.shareConfirmTitle')}
      </ModalHeader>

      <ModalBody>
        <p className="mb-0 fs-5">
          {t('sales.quotes.shareMessage')}
        </p>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-secondary btn-sm" onClick={toggle}>{t('common.cancel')}</button>
        <button className="btn btn-primary btn-sm" onClick={() => {
          onConfirm();
          toggle();
        }}>{t('common.share')}</button>
      </ModalFooter>
    </Modal>
  );
}

export default ShareConfirmationModal;